import { expected } from '@aloft/toolkit-shared';

import { PairedSaleIDs } from '../../types.ts';

export const getSelectedAndActiveRowIndices = ({
  pairs,
  activePair,
  selectedPairs,
}: {
  pairs: PairedSaleIDs[];
  activePair: PairedSaleIDs | null;
  selectedPairs: PairedSaleIDs[];
}): {
  activeRowIndex: number;
  selectedRowIndices: number[];
} => {
  let activeRowIndex = -1;
  const selectedRowIndices: number[] = [];

  const selectedPairsSet = new Set(selectedPairs.map((pair) => pair.p1 + pair.p2));

  for (let i = 0; i < pairs.length; i += 1) {
    const pair = expected(pairs[i]);

    const vals = Object.values(activePair ?? {});

    // The user may have swapped the properties, so we need to check both (applies below as well)
    if (vals.includes(pair.p1) && vals.includes(pair.p2)) {
      activeRowIndex = i;
    }

    if (selectedPairsSet.has(pair.p1 + pair.p2) || selectedPairsSet.has(pair.p2 + pair.p1)) {
      selectedRowIndices.push(i);
    }
  }

  return {
    selectedRowIndices,
    activeRowIndex,
  };
};
